import $ from 'jquery';

var loginpage = {};

loginpage.init = function() {
    loginpage.validateStart();
};

loginpage.validateStart = function() {
    $('#loginPageForm').on('submit', function() {
        $("#couponcode").val($.trim($("#couponcode").val()));

        var success = true;
        if($('.postcodeBox').length > 0) {
            var match = /^[1-9]{1}[0-9]{3}\s?[A-Z]{2}$/i;
            if(($('#input_postcode').val()).match(match)) {
                $('#input_postcode').css("backgroundColor", "#DEF8CA");
            }
            else {
                success = false;
                $('#input_postcode').css("backgroundColor", "#d80000");
            }
            match = /([0-9]{1})/;
            if(($('#input_number').val()).match(match)) {
                $('#input_number').css("backgroundColor", "#DEF8CA");
            }
            else {
                success = false;
                $('#input_number').css("backgroundColor", "#d80000");
            }
        }

        return success;
    });

};

export default loginpage;
